// extracted by mini-css-extract-plugin
module.exports = {"sidebarToggler":"styles_sidebarToggler__3nYH-","closed":"styles_closed__2TeDg","wrapper":"styles_wrapper__1sQOr","open":"styles_open__cTuFl"};